<div class="pr-3 py-4 pl-4 h-full w-full flex flex-col">
   <breadcrumbs [items]="breadcrumbs"></breadcrumbs>
   <div class="flex justify-between">
      <div class="mt-3 mb-6 text-2xl font-medium">Sample 7</div>
      <div class="btn-option flex mt-3 mb-6">
         <button class="mr-3" nz-button nzType="primary" (click)="showPopup()">
            <span>Popup</span>
         </button>
         <button class="mr-3" nz-button nzType="primary" (click)="openDrawer()">Drawer</button>
      
         <button class="mr-3" nz-button nzType="primary" (click)="Import()">Import</button>
       
         <nz-upload
         nzAction="https://www.mocky.io/v2/5cc8019d300000980a055e76"
         [nzHeaders]="{ authorization: 'authorization-text' }"
         (nzChange)="handleChange($event)"
         >
         <button nz-button class="mr-3">Export</button>
         </nz-upload>
      </div>
   </div>
   <div class="flex mt-3 mb-6">
      <nz-input-group class="mr-3" [nzSuffix]="suffixIconSearch">
         <input  type="text" nz-input placeholder="Tìm kiếm" />
      </nz-input-group>
      <ng-template #suffixIconSearch>
         <i nz-icon nzType="search"></i>
      </ng-template>
      <button class="mr-3" nz-button nzType="primary">Tìm kiếm</button>
      <button class="mr-3" nz-button nzType="default" >Elastic Search</button>
      <button nz-button nzType="text" *ngIf="isOpen === false" (click)="onclickOpen()">Mở rộng<i nz-icon nzType="down" nzTheme="outline"></i></button>
      <button nz-button nzType="text" *ngIf="isOpen === true" (click)="onclickOpen()">Đóng<i nz-icon nzType="up" nzTheme="outline"></i></button>
   </div>
   <div *ngIf="isOpen" class="flex mb-6">
      <nz-select class="mr-3" ngModel="lucy" nzAllowClear nzPlaceHolder="Choose">
         <nz-option nzValue="lucy" nzLabel="Lucy"></nz-option>
      </nz-select>
      <nz-select class="mr-3" nzAllowClear nzPlaceHolder="Select OS">
         <nz-option nzLabel="Windows" nzValue="windows"></nz-option>
         <nz-option nzLabel="Apple" nzValue="apple"></nz-option>
         <nz-option nzLabel="Android" nzValue="android"></nz-option>
       </nz-select>
      <nz-select class="mr-3" ngModel="lucy" nzAllowClear nzPlaceHolder="Choose">
      <nz-option nzValue="lucy" nzLabel="Lucy"></nz-option>
      </nz-select>
   </div>
   <div>
      <nz-table #filterTable [nzData]="listOfData" nzTableLayout="fixed" [nzFrontPagination]="true" [nzSimple]="true">
         <thead>
           <tr>
              <th nz-checkbox [(ngModel)]="allChecked" (ngModelChange)="updateAllChecked()" [nzIndeterminate]="indeterminate"></th>
             <th
               *ngFor="let column of listOfColumns"
               [nzSortOrder]="column.sortOrder"
               [nzSortFn]="column.sortFn"
               [nzSortDirections]="column.sortDirections"
               [nzFilterMultiple]="column.filterMultiple"
               [nzFilters]="column.listOfFilter"
               [nzFilterFn]="column.filterFn"
             >
               {{ column.name }}
             </th>
             <th>Action</th>
           </tr>
         </thead>
         <tbody>
           <tr  *ngFor="let data of filterTable.data">
             <td>
               <label nz-checkbox [(ngModel)]="data.check" (ngModelChange)="updateSingleChecked()"> 
                </label>
             </td> 
             <td>{{ data.name }}</td>
             <td>{{ data.age }}</td>
             <td>{{ data.nickName }}</td>
             <td><label nz-checkbox nzDisabled [ngModel]="data.employee"></label></td>
             <td>
               <a nz-popconfirm nzPopconfirmTitle="Sure to delete?" (nzOnConfirm)="deleteRow()">Delete</a>
             </td>
           </tr>
         </tbody>
       </nz-table>
   </div>   
</div>